module.exports = __webpack_public_path__ + "static/media/mobile-bg.4efd6105.png";